// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__bZdeP","emails":"CreateEditClinics_emails__j-Lxo","emailTagLabel":"CreateEditClinics_emailTagLabel__1lIim"};